import { useEffect } from 'react'
import {
  EditorContent,
  useEditor,
  EditorContentProps,
  Extensions,
} from '@tiptap/react'
import Paragraph from '@tiptap/extension-paragraph'
import Document from '@tiptap/extension-document'
import Text from '@tiptap/extension-text'
import Placeholder from '@tiptap/extension-placeholder'
import cx from 'classnames'

import styles from './BaseEditor.module.css'

type BaseEditorProps = Omit<EditorContentProps, 'ref' | 'editor'> & {
  onUpdate: (value: string) => void
  extensions?: Extensions
}

export const BaseEditor = ({
  placeholder,
  className,
  onUpdate,
  autoFocus,
  extensions,
  ...rest
}: BaseEditorProps) => {
  const editor = useEditor({
    extensions: [
      Document,
      Paragraph,
      Text,
      Placeholder.configure({
        placeholder,
      }),
      ...(extensions ? extensions : []),
    ],
    content: '',
    onUpdate: ({ editor }) => {
      onUpdate(editor.getText())
    },
  })

  useEffect(() => {
    if (editor !== null && !editor.isDestroyed && autoFocus) {
      editor.commands.focus()
    }
  }, [editor, autoFocus])

  return (
    <EditorContent
      {...rest}
      data-editor
      className={cx(styles.BaseEditor, className)}
      editor={editor}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
        }
      }}
    />
  )
}
